import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { IChecklistBenchmarkViewData } from '../checklists-benchmark/checklists-benchmark.component';

@Component({
    selector: 'fi-benchmark-item-info-tooltip',
    template: `
        <div class="checklist-info-tooltip-container">
            <mat-icon class="tooltip-icon far fa-circle-info" />

            <fi-info-icon
                tooltipClass="checklist-benchmark-tooltip fi-rounded-white-tooltip"
                fiInfoPositionMobile="left"
                [mode]="FiInfoIconMode.WithoutIconAbsolute"
            >
                <div class="checklist-info-header">
                    <mat-icon class="far fa-circle-exclamation BrandedColor"></mat-icon>
                    <span class="heading">{{ 'checklist.checklist_details' | fiAppText }}:</span>
                </div>
                <div class="checklist-info">
                    <div class="checklist-info-column">
                        <span class="info-category">{{ 'checklist.checklist_name_placeholder' | fiAppText }}</span>
                        <span class="info-category">{{ 'checklist.schedule_name' | fiAppText }}</span>
                        <span class="info-category">{{ 'common.created_by' | fiAppText }}</span>
                        <span class="info-category">{{ 'common.closed' | fiAppText }}</span>
                    </div>
                    <div class="checklist-info-column">
                        <span class="info-category-value">{{ checklistName }}</span>
                        <span class="info-category-value">{{ benchmarkViewData.ScheduleName }}</span>
                        <span class="info-category-value">{{ benchmarkViewData.CreatedByUserName }}</span>
                        <span class="info-category-value">{{
                            benchmarkViewData.DueDateTime
                                | fiFormatDate: FiDateTimeFormatOptions : { showToday: false, showUTC: true }
                        }}</span>
                    </div>
                </div>
            </fi-info-icon>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-benchmark-item-info-tooltip' },
    standalone: false,
})
export class FiChecklistHistoryBenchmarkItemInfoTooltipComponent {
    @Input({ required: true }) benchmarkViewData: IChecklistBenchmarkViewData;
    @Input({ required: true }) checklistName: string;

    protected readonly FiDateTimeFormatOptions = FiDateTimeFormatOptions;
    protected readonly FiInfoIconMode = FiInfoIconMode;
}
